var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoThemeDarkActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.5624C19.9223 15.0115 18.7661 15.242 17.5985 15.2405C12.7167 15.2405 8.75949 11.2833 8.75949 6.40145C8.75949 5.19571 9.00064 4.04709 9.43761 3C7.82706 3.67187 6.45134 4.8053 5.48372 6.25754C4.5161 7.70977 3.99985 9.41587 4 11.1609C4 16.0428 7.95718 20 12.8391 20C14.5841 20.0001 16.2902 19.4839 17.7425 18.5163C19.1947 17.5487 20.3281 16.1729 21 14.5624Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoThemeDarkActive);
export default __webpack_public_path__ + "static/media/ico-theme-dark-active.f834ca64c86481ec6d5a86a3575f91fd.svg";
export { ForwardRef as ReactComponent };